import React from 'react'
import Link from 'gatsby-link'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import HomeIcon from '@material-ui/icons/Home';

import Container from '../components/container'
import Hexagons from '../components/hexagons'

class NotFoundPage extends React.Component {
  title = `We can't find the page you asked for`;
  subtitle = `Either the URL was mistyped or the page may no longer be available`;
  button = `Take Me Home`;

  styles = {
    link: {
      display: 'block',
      textAlign: 'center',
    },

    button: {
      margin: '1rem 0',
    },

    icon: {
      marginLeft: '1rem',
    }
  };

  render() {
    return (
      <Container
        size='tiny'
        padding='2rem'
        align='center'
      >

        <Typography variant="h5">
          {this.title}
        </Typography>

        <Typography
          variant='body1'
          color="textSecondary"
        >
          {this.subtitle}
        </Typography>

        <Link to='/' >
          <Button
            size="large"
            variant='outlined'
            color='primary'
            style={this.styles.button}
          >
            {this.button}
            <HomeIcon style={this.styles.icon} />
          </Button>
        </Link>

        <Hexagons />

      </Container>
    )
  }
}

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js